import React, { FC } from 'react';

import { Alert, AlertIcon, Box } from '@chakra-ui/react';

interface Props {
  title?: string;
  description?: string;
}

export const FormActionErrorMessage: FC<Props> = props => {
  const { title, description } = props;
  return (
    <Box w="full">
      <Alert status={'error'} borderRadius={6} title={title}>
        <AlertIcon />
        {description}
      </Alert>
    </Box>
  );
};
